import React from 'react';
import { renderIf } from '../../helpers';

interface IRenderIfProps {
  condition: boolean | null | undefined;
  children: JSX.Element;
  alternative?: JSX.Element;
}

const RenderIf: React.FC<IRenderIfProps> = ({ condition, children, alternative }) =>
  renderIf(!!condition, children, alternative);

export default RenderIf;

export type { IRenderIfProps };
